<template>
    <div id="formErrors" v-if="errors.length > 0" class="row">
        <div class="col-xs-12 alert alert-danger">
            <h3 :is="`h${headingLevel}`">{{ heading }}</h3>
            <ul>
                <li v-for="error in errors">{{ error }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            heading: {
                type: String,
                default: 'Whoops! We ran into a few issues:',
            },
            headingLevel: {
                type: Number,
                default: 3,
            },
            errors: {
                type: Array,
                required: true,
            },
        },
    };
</script>

<style lang="scss">
    #formErrors {
        margin: 0;
        padding-top: 0;
        h3 {
            margin: 5px 0;
            font-size: 15px;
            font-weight: bold;
        }
        div.alert-danger {
            border: 1px solid #e86a6b;
            background: #FFF8F9;
            text-align: left;
            color: #333;
            border-radius: 5px;
            padding: 15px;
            width: 100%;
        }
        ul {
            padding-left: 35px;
            li {
                font-size: 14px;
            }
        }
    }
</style>
